import { OktaAuthService } from "./auth-okta.service";
import { AuthenticationService } from "./authentication.service";
import { AuthenticationConfiguration } from "./authentication-configuration.service";

/**
 * A provider that uses an {@link AuthenticationFactory} to dynamically
 * implement an {@link AuthenticationService}.
 *
 * @author    John Ying <john.ying@childrenshospitals.org>
 * @created   9/22/2022
 */
export const AuthenticationServiceProvider =
{
  provide: AuthenticationService,
  useFactory: AuthenticationFactory,
  deps: [AuthenticationConfiguration]
}

/**
 * Instantiates an {@link AuthenticationService} from an {@link AuthenticationConfiguration}.
 *
 * @param authenticationConfiguration - the configuration settings
 *
 * @returns the implemented authentication service
 */
export function AuthenticationFactory(authenticationConfiguration: AuthenticationConfiguration): AuthenticationService {
  if (authenticationConfiguration.authorizationProvider === 'okta') {
    return new OktaAuthService(
      authenticationConfiguration.storageService,
      authenticationConfiguration.colorUtil,
      authenticationConfiguration.oktaBare,
      authenticationConfiguration.router,
      authenticationConfiguration.userService
    );
  }
  else {
    throw new Error("Authentication Configuration authorization provider is not valid.")
  }
}
